import { Box, Stack, useTheme } from '@mui/material';
import { Header } from './Header.tsx';
import { Outlet } from 'react-router-dom';

// TODO: context to set header content?
export const ContentWithHeaderLayout = () => {
  const theme = useTheme();
  return (
    <Stack direction="column" sx={{ height: '100%' }}>
      <Box
        sx={{
          width: '100%',
          height: '100px',
          position: 'sticky',
          top: 0,
          zIndex: 1100,
          boxShadow: `0px 12px 16px -4px ${theme.palette.shadows.dark}`,
          backdropFilter: 'blur(10px)',
        }}
      >
        <Header />
      </Box>
      <Box
        flex={1}
        sx={{
          background: theme.palette.grey[25],
          overflow: 'auto',
          pt: '124px',
          pb: theme.spacing(4),
          px: theme.spacing(4),
          mt: '-100px',
        }}
      >
        <Outlet />
      </Box>
    </Stack>
  );
};
